module.exports = __webpack_public_path__ + "img/image9@3x.ec07ab6d.png";